import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: '1rem',
    right: '1rem'
  }
}))

export default useStyles
